module.exports = __webpack_public_path__ + "static/img/down-arrow-dark.1bf60caf.svg";